<script setup lang="ts">
import { RefreshCcw04 } from "utruckin-icons";
import CommonButton from "@/components/common/CommonButton.vue";
import { useRouter } from "vue-router";

const router = useRouter();

const goBack = () => {
  router.go(-1);
};

const goHome = () => {
  router.push("/");
};
</script>

<template>
  <div class="v-error">
    <div class="main">
      <div class="main__content">401</div>

      <div class="main__headline">Unauthorized</div>

      <div class="main__description">Please log in to access this page.</div>

      <div class="main__action">
        <CommonButton
          @click="goBack"
          type="outline"
          prepend
          :prepend-icon="RefreshCcw04"
          label="Refresh"
        ></CommonButton>
        <CommonButton @click="goHome" type="primary" label="Go to home" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
